var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListNumberedEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(-1096 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    transform: "translate(1096 360)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(1096 360)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x2: 13,
    transform: "translate(8 6)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x2: 13,
    transform: "translate(8 12)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x2: 13,
    transform: "translate(8 18)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x2: 0.01,
    transform: "translate(3 6)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x2: 0.01,
    transform: "translate(3 12)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x2: 0.01,
    transform: "translate(3 18)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumberedEditorIcon);
export default __webpack_public_path__ + "static/media/list-numbered-editor-icon.83ed6e205cf1c372c836eb0091cb55c2.svg";
export { ForwardRef as ReactComponent };